import { Controller } from '@hotwired/stimulus';

export default class TabController extends Controller {
  static targets = ['tab', 'pane', 'wrapper'];
  static values = {
    shouldReload: Boolean,
  };

  connect() {
    window.addEventListener('popstate', this.handlePopState);
  }

  disconnect() {
    window.removeEventListener('popstate', this.handlePopState);
  }

  handleTabClick(event) {
    event.preventDefault();
    const clickedTab = event.currentTarget;

    const href = clickedTab.getAttribute('href');
    this.activateTab(clickedTab.dataset.category);
    if (this.shouldReloadValue) {
      window.location = href;
      return;
    }
    history.pushState(null, '', href);
  }

  handlePopState = () => {
    const matchingTab = this.tabTargets.find((tab) => tab.getAttribute('href') === window.location.pathname);

    if (matchingTab) {
      this.activateTab(matchingTab.dataset.category);
    }
  };

  activateTab(category) {
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.category === category;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.paneTargets.forEach((pane) => {
      const isActive = pane.id === category;
      pane.classList.toggle('show', isActive);
      pane.classList.toggle('active', isActive);
    });
  }

  handleScroll = (event) => {
    const scrollElement = event.currentTarget;
    const hasReachedEnd = scrollElement.scrollLeft + scrollElement.clientWidth >= scrollElement.scrollWidth - 1;

    this.wrapperTarget.classList.toggle('wrapper-end', hasReachedEnd);
  };
}
